"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const darkTheme = {
    colors: {
        primary: "#008547",
        background: "#14141a",
        backgroundInBetween: "#16161c",
        backgroundVariant: "#1a1a21",
        backgroundInput: "rgba(255, 255, 255, 0.03)",
        textPrimary: "#fff",
        textSecondary: "rgba(255, 255, 255, 0.54)",
        textInvertedPrimary: "rgba(0, 0, 0, 0.8)",
        textInvertedSecondary: "rgba(0, 0, 0, 0.5)",
        textOnPrimary: "#fff",
        textOnColor: "rgba(0, 0, 0, 0.8)",
        border: "rgba(255, 255, 255, 0.14)",
        borderDim: "rgba(255, 255, 255, 0.05)",
        action: "#29c3f9",
        actionAlternate: "#2a2a36",
        warning: "#ed3a29",
        neutral: "#f4cf27",
        good: "#31f762",
        warningBackground: "#d42626",
        neutralBackground: "#9e5f00",
        goodBackground: "#026e2d",
    },
    spacing: {
        xs: "0.64rem",
        small: "1.25rem",
        medium: "1.953rem",
        large: "3.052rem",
    },
    sizes: {
        negTwo: "0.64rem",
        negOne: "0.8rem",
        base: "1rem",
        plusOne: "1.25rem",
        plusTwo: "1.563rem",
        plusThree: "1.953rem",
        plusFour: "2.441rem",
        plusFive: "3.052rem",
    },
    shadows: {
        normal: "0 2px 0 rgba(0, 0, 0, 0.18)",
        large: "0 8px 12px rgba(0, 0, 0, 0.05)",
        primary: "0 2px 0 #14585a",
        alternate: "0 2px 0 #1d1d25",
    },
};
exports.darkTheme = darkTheme;
const lightTheme = {
    colors: {
        primary: "#008547",
        background: "#f9f9f9",
        backgroundInBetween: "#fcfcfc",
        backgroundVariant: "#ffffff",
        backgroundInput: "rgba(0, 0, 0, 0.035)",
        textPrimary: "rgba(0, 0, 0, 0.95)",
        textSecondary: "rgba(0, 0, 0, 0.54)",
        textInvertedPrimary: "rgba(255, 255, 255, 0.95)",
        textInvertedSecondary: "rgba(255, 255, 255, 0.5)",
        textOnPrimary: "#fff",
        textOnColor: "rgba(0, 0, 0, 0.8)",
        border: "rgba(0, 0, 0, 0.14)",
        borderDim: "rgba(0, 0, 0, 0.05)",
        action: "#0063CC",
        actionAlternate: "#eee",
        warning: "#ed3a29",
        neutral: "#f4cf27",
        good: "#31f762",
        warningBackground: "#ff7878",
        neutralBackground: "#f4cf27",
        goodBackground: "#b6eec7",
    },
    spacing: {
        xs: "0.64rem",
        small: "1.25rem",
        medium: "1.953rem",
        large: "3.052rem",
    },
    sizes: {
        negTwo: "0.64rem",
        negOne: "0.8rem",
        base: "1rem",
        plusOne: "1.25rem",
        plusTwo: "1.563rem",
        plusThree: "1.953rem",
        plusFour: "2.441rem",
        plusFive: "3.052rem",
    },
    shadows: {
        normal: "0 2px 0 rgba(0, 0, 0, 0.07)",
        large: "0 8px 12px rgba(0, 0, 0, 0.05)",
        primary: "0 2px 0 #14585a",
        alternate: "0 2px 0 #d1d1d1",
    },
};
exports.lightTheme = lightTheme;
